import styled from "styled-components";
import { Grid, Flex, Box, Stack, Text } from "@mantine/core";
import { CardStatus } from "../../components/Card/CardStatus";
import { CardContainer } from "../../components/Container/CardContainer";
import { CardContainerRetro } from "../../components/Container/CardContainerRetro";
import { Avatar, Title, Button } from "@mantine/core";
import { IconCalendar, IconShare, IconCheck } from "@tabler/icons-react";
import { SectionTitleWithExp } from "../../components/customTypo/SectionTitleWithExp";
import { Section } from "../../components/Container/Section";
import { useIsMobile } from "../../hooks/useIsMobile";
import { IconThreads } from "../../assets/icon/metric/IconThreads";
import moment from "moment";
import { useState } from "react";

import colorsCustom from "../../designTokens/colorsCustom";
const Col = styled(Grid.Col)`
	padding: 0 16px;
`;

const Block = styled(Flex)`
	border-right: ${(props) =>
		`solid ${props.$isEnd ? "0" : "0.5px"} ${colorsCustom.ui.dark.subtle}`};
	margin-bottom: ${(props) => (props.$isMobile ? "16px" : "0px")};
`;

export const UserInfoSummarySection = ({
	insight,
	profile,
	monthlyViews,
	postLoading = true,
	firstThreadDate,
}) => {
	const isMobile = useIsMobile();
	const [copySuccess, setCopySuccess] = useState(false);

	const handleShareProfile = async () => {
		const shareUrl = `${window.location.origin}/user/${profile.id}`;
		
		try {
			await navigator.clipboard.writeText(shareUrl);
			setCopySuccess(true);
			setTimeout(() => setCopySuccess(false), 2000);
		} catch (err) {
			console.error('Failed to copy: ', err);
			// Fallback for older browsers
			const textArea = document.createElement('textarea');
			textArea.value = shareUrl;
			document.body.appendChild(textArea);
			textArea.select();
			document.execCommand('copy');
			document.body.removeChild(textArea);
			setCopySuccess(true);
			setTimeout(() => setCopySuccess(false), 2000);
		}
	};
	return (
		<Section>
			<Flex 
				w="100%" 
				justify="space-between" 
				align={isMobile ? "flex-start" : "center"}
				direction={isMobile ? "column" : "row"}
				gap={isMobile ? 16 : 0}
			>
				<SectionTitleWithExp
					isMobile={isMobile}
					title="My Account"
					// exp="Check your key performance of your account since 2024 Jun!"
				/>
				<Button
					variant="filled"
					leftSection={copySuccess ? <IconCheck size={16} /> : <IconShare size={16} />}
					onClick={handleShareProfile}
					color={copySuccess ? "green" : "dark"}
					size={isMobile ? "sm" : "md"}
					radius="xl"
				>
					{copySuccess ? "복사됨!" : "프로필 공유"}
				</Button>
			</Flex>
			<CardContainerRetro bg={colorsCustom.paper} w={"100%"} weight="bold" rd={16}>
				<Flex
					w={"100%"}
					p={isMobile ? "16px 0px 0px 0px" : "24px 8px"}
					gap={24}
					direction={"column"}
				>
					<Grid
						direction={"row"}
						w={"100%"}
						h={isMobile ? "auto" : 109}
						gutter={0}
						p={"0px"}
						style={{
							display: "flex",
							alignItems: "stretch",
							minHeight: "100%",
						}}
					>
						<Col span={isMobile ? 12 : 4}>
							<Block gap={24} $isEnd={isMobile} $isMobile={isMobile}>
								<Box
									w={"fit-content"}
									h={"fit-content"}
									style={{
										borderRadius: "50%",
										padding: 8,
										border: `4px solid ${colorsCustom.ui.dark.bold}`,
									}}
								>
									<Avatar
										size={isMobile ? 56 : 72}
										src={profile?.threads_profile_picture_url}
									/>
								</Box>
								<Stack gap={20}>
									<Stack gap={0}>
										<Title
											order={isMobile ? 5 : 4}
											fw={700}
											mb={isMobile ? 8 : 16}
										>
											{profile?.username}
										</Title>
										<Text fz={isMobile ? "md" : "lg"}>
											{moment(firstThreadDate).format("MMM D, YYYY")}
										</Text>
										<Flex gap={4} align={"center"}>
											<IconThreads size={16} />
											<Text fz={isMobile ? "md" : "lg"}>
												{insight.numThreads} threads
											</Text>
										</Flex>
									</Stack>
								</Stack>
							</Block>
						</Col>
						<Col span={isMobile ? 6 : "auto"}>
							<Block $isMobile={isMobile}>
								<CardStatus
									isMobile={isMobile}
									type={"follower"}
									value={insight.followers.value}
									postLoading={postLoading}
								/>
							</Block>
						</Col>
						<Col span={isMobile ? 6 : "auto"}>
							<Block $isMobile={isMobile}>
								<CardStatus
									isMobile={isMobile}
									type={"like"}
									value={insight.likes.value}
									postLoading={postLoading}
								/>
							</Block>
						</Col>
						<Col span={isMobile ? 6 : "auto"}>
							<Block $isMobile={isMobile}>
								<CardStatus
									isMobile={isMobile}
									type={"reply"}
									value={insight.replies.value}
									postLoading={postLoading}
								/>
							</Block>
						</Col>
						<Col span={isMobile ? 6 : "auto"}>
							<Block $isMobile={isMobile} $isEnd={true}>
								<CardStatus
									isMobile={isMobile}
									type={"repost"}
									value={insight.reposts.value}
									postLoading={postLoading}
								/>
							</Block>
						</Col>
					</Grid>
				</Flex>
			</CardContainerRetro>
		</Section>
	);
};
